// extracted by mini-css-extract-plugin
export default {"control":"control_control__Sq5Zu","button":"control_button__9fGGP"};